/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../Managment/search/managementSearch.component.ngfactory';
import * as i2 from '../../../../app/components/Managment/search/managementSearch.component';
import * as i3 from './tabs/fill-order-tab/fill-order-tab.component.ngfactory';
import * as i4 from '../../../../app/components/calculator/tabs/fill-order-tab/fill-order-tab.component';
import * as i5 from './tabs/calculator-tab/calculatorTab.component.ngfactory';
import * as i6 from '../../../../app/components/calculator/tabs/calculator-tab/calculatorTab.component';
import * as i7 from 'ng2-toastr/src/toast-manager';
import * as i8 from '../../../../app/services/orderService';
import * as i9 from '@angular/router';
import * as i10 from '../../../../app/services/emailService';
import * as i11 from '../../../../app/services/configService';
import * as i12 from '../../../../app/services/uploadService';
import * as i13 from '../Managment/orderManagement/orderData/orderData.component.ngfactory';
import * as i14 from '../../../../app/components/Managment/orderManagement/orderData/orderData.component';
import * as i15 from '../../../../app/services/orderContentService';
import * as i16 from '../../../../app/components/calculator/calculator.component';
import * as i17 from './modals/aafee-change-modal.component.ngfactory';
import * as i18 from '../../../../app/components/calculator/modals/aafee-change-modal.component';
import * as i19 from '@angular/common';
import * as i20 from '../../../node_modules/ngx-wizard/ngx-wizard.ngfactory';
import * as i21 from 'ngx-wizard';
import * as i22 from '../../../../app/services/extraDataService';
import * as i23 from '../../../../app/services/publisher.service';
const styles_CalculatorComponent:any[] = ([] as any[]);
export const RenderType_CalculatorComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CalculatorComponent,data:{}});
function View_CalculatorComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),6,'div',[['class',
      'row order-id mobile-show']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵeld(0,(null as any),(null as any),
      1,'span',[['class','order-title']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['Quote ID:'])),
      (_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),[' ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.order.Id;
        _ck(_v,5,0,currVal_0);
      });
}
function View_CalculatorComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'management-search',
      [['createIcon','iso']],(null as any),[[(null as any),'searchEventEmitter'],[(null as any),
          'queryChange'],[(null as any),'createEventEmitter']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('searchEventEmitter' === en)) {
          const pd_0:any = ((<any>_co.goToSearch()) !== false);
          ad = (pd_0 && ad);
        }
        if (('queryChange' === en)) {
          const pd_1:any = ((<any>(_co.query = $event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('createEventEmitter' === en)) {
          const pd_2:any = ((<any>_co.createEvent()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i1.View_ManagementSearchComponent_0,i1.RenderType_ManagementSearchComponent)),
      i0.ɵdid(49152,(null as any),0,i2.ManagementSearchComponent,([] as any[]),{showCreate:[0,
          'showCreate'],createIcon:[1,'createIcon'],query:[2,'query'],showCleanFilter:[3,
          'showCleanFilter']},{searchEventEmitter:'searchEventEmitter',createEventEmitter:'createEventEmitter',
          queryChange:'queryChange'}),(_l()(),i0.ɵted(0,[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    const currVal_1:any = 'iso';
    const currVal_2:any = _co.query;
    const currVal_3:boolean = !_co.stringLink.isNullOrEmpty(_co.query);
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_CalculatorComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'div',[['class',
      'spinner']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_CalculatorComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'fill-order-tab',
      ([] as any[]),(null as any),[[(null as any),'orderChange'],[(null as any),'extraDataChange']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('orderChange' === en)) {
          const pd_0:any = ((<any>(_co.order = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('extraDataChange' === en)) {
          const pd_1:any = ((<any>(_co.extraData = $event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_FillOrderTabComponent_0,i3.RenderType_FillOrderTabComponent)),i0.ɵdid(49152,
      [[1,4],['fillOrder',4]],0,i4.FillOrderTabComponent,[i0.Renderer2],{order:[0,
          'order'],canadianCurrencyCodes:[1,'canadianCurrencyCodes'],wizard:[2,'wizard'],
          extraData:[3,'extraData'],disableChanges:[4,'disableChanges'],isPublic:[5,
              'isPublic'],isOrderDetails:[6,'isOrderDetails'],sendCustomer:[7,'sendCustomer']},
      {extraDataChange:'extraDataChange'})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.order;
    const currVal_1:any = _co.canadianCurrencyCodes;
    const currVal_2:any = i0.ɵnov((<any>_v.parent),23);
    const currVal_3:any = _co.extraData;
    const currVal_4:any = _co.disableChanges;
    const currVal_5:any = _co.isPublic;
    const currVal_6:any = _co.isOrderDetails;
    const currVal_7:any = _co.sendCustomer;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
  },(null as any));
}
function View_CalculatorComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'div',[['class',
      'spinner']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_CalculatorComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'calculator-tab',
      ([] as any[]),(null as any),[[(null as any),'orderChange'],[(null as any),'clonedOrderChange']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('orderChange' === en)) {
          const pd_0:any = ((<any>(_co.order = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('orderChange' === en)) {
          const pd_1:any = ((<any>_co.orderChange.emit($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('clonedOrderChange' === en)) {
          const pd_2:any = ((<any>(_co.clonedOrder = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i5.View_CalculatorTabComponent_0,i5.RenderType_CalculatorTabComponent)),i0.ɵdid(4243456,
      [[6,4]],0,i6.CalculatorTabComponent,[i7.ToastsManager,i8.OrderService,i9.Router,
          i10.EmailService,i11.ConfigService,i12.UploadService],{isPublic:[0,'isPublic'],
          order:[1,'order'],wizard:[2,'wizard'],canadianCurrencyCodes:[3,'canadianCurrencyCodes'],
          disableChanges:[4,'disableChanges'],isOrderDetails:[5,'isOrderDetails'],
          orderDataComp:[6,'orderDataComp'],clonedOrder:[7,'clonedOrder']},{orderChange:'orderChange'})],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.isPublic;
        const currVal_1:any = _co.order;
        const currVal_2:any = i0.ɵnov((<any>_v.parent),23);
        const currVal_3:any = _co.canadianCurrencyCodes;
        const currVal_4:any = _co.disableChanges;
        const currVal_5:any = _co.isOrderDetails;
        const currVal_6:any = _co.orderDataComponent;
        const currVal_7:any = _co.clonedOrder;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7);
      },(null as any));
}
function View_CalculatorComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'div',[['class',
      'spinner']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_CalculatorComponent_8(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'order-data',([] as any[]),
      (null as any),[[(null as any),'orderChange'],[(null as any),'tabChanged']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('orderChange' === en)) {
          const pd_0:any = ((<any>(_co.order = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('orderChange' === en)) {
          const pd_1:any = ((<any>_co.orderChange.emit($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('tabChanged' === en)) {
          const pd_2:any = ((<any>_co.tabChanged.emit($event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i13.View_OrderDataComponent_0,i13.RenderType_OrderDataComponent)),i0.ɵdid(638976,
      [[4,4]],0,i14.OrderDataComponent,[i7.ToastsManager,i8.OrderService,i11.ConfigService,
          i15.OrderContentService,i10.EmailService,i9.ActivatedRoute],{order:[0,'order']},
      {orderChange:'orderChange',tabChanged:'tabChanged'}),(_l()(),i0.ɵted((null as any),
      [' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.order;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_CalculatorComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(671088640,1,{fillOrderTab:0}),i0.ɵqud(402653184,2,{calculatorWizard:0}),
      i0.ɵqud(402653184,3,{tabDirective:0}),i0.ɵqud(671088640,4,{orderDataComponent:0}),
      i0.ɵqud(402653184,5,{orderDataTab:0}),i0.ɵqud(671088640,6,{calculatorTabComponent:0}),
      i0.ɵqud(402653184,7,{aaChangeModal:0}),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'aa-fee-change-modal',([] as any[]),(null as any),[[(null as any),'modalHidden']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i16.CalculatorComponent = _v.component;
            if (('modalHidden' === en)) {
              const pd_0:any = ((<any>_co.modalHiddenHandler($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i17.View_AaFeeChangeModalComponent_0,i17.RenderType_AaFeeChangeModalComponent)),
      i0.ɵdid(49152,[[7,4],['aaChangeModal',4]],0,i18.AaFeeChangeModalComponent,([] as any[]),
          {order:[0,'order']},{modalHidden:'modalHidden'}),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),52,'div',[['class',
          'main-content calculator'],['id','calculator']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CalculatorComponent_1)),i0.ɵdid(16384,(null as any),0,i19.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),46,'div',[['class',
          'container-fluid']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CalculatorComponent_2)),
      i0.ɵdid(16384,(null as any),0,i19.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),40,'div',[['class','row']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),37,'wizard',[['data-color',
          'cyan']],(null as any),(null as any),(null as any),i20.View_WizardComponent_0,
          i20.RenderType_WizardComponent)),i0.ɵdid(4440064,[[2,4],['calculatorWizard',
          4]],0,i21.WizardComponent,[i0.ElementRef],(null as any),(null as any)),i0.ɵprd(2048,
          (null as any),i21.TabsComponent,(null as any),[i21.WizardComponent]),(_l()(),
          i0.ɵted(1,[' '])),(_l()(),i0.ɵeld(0,(null as any),1,8,'tab',[['heading',
          'Customer and Product Information'],['icon','info_outline'],['nextButton',
          'hidden']],[[2,'active',(null as any)],[2,'tab-pane',(null as any)]],[[(null as any),
          'check'],[(null as any),'isSelect']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i16.CalculatorComponent = _v.component;
        if (('check' === en)) {
          const pd_0:any = ((<any>_co.checkFillOrderForm($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('isSelect' === en)) {
          const pd_1:any = ((<any>_co.onFistTabSelected()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(212992,[[3,4]],0,i21.TabDirective,[i21.TabsComponent,
          i0.ElementRef],{heading:[0,'heading'],icon:[1,'icon'],nextButton:[2,'nextButton'],
          index:[3,'index'],active:[4,'active']},{check:'check',isSelect:'isSelect'}),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CalculatorComponent_3)),i0.ɵdid(16384,
          (null as any),0,i19.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CalculatorComponent_4)),
      i0.ɵdid(16384,(null as any),0,i19.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted(1,[' '])),(_l()(),i0.ɵeld(0,(null as any),1,8,'tab',[['heading',
          'Rate Calculator'],['nextButton','hidden'],['previousButton','hidden']],
          [[2,'active',(null as any)],[2,'tab-pane',(null as any)]],[[(null as any),
              'isSelect']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i16.CalculatorComponent = _v.component;
            if (('isSelect' === en)) {
              const pd_0:any = ((<any>(((_co.firstAttempt && (_co.order.Status == _co.orderStatus.Calculated)) && _co.isFirstTabOpened)? _co.calculateOrder($event): _co.showModal($event))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(212992,[[3,4]],0,i21.TabDirective,
          [i21.TabsComponent,i0.ElementRef],{heading:[0,'heading'],icon:[1,'icon'],
              previousButton:[2,'previousButton'],nextButton:[3,'nextButton'],index:[4,
                  'index'],active:[5,'active']},{isSelect:'isSelect'}),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CalculatorComponent_5)),i0.ɵdid(16384,(null as any),0,i19.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CalculatorComponent_6)),i0.ɵdid(16384,(null as any),0,i19.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵted(1,[' '])),(_l()(),i0.ɵeld(0,[[5,0],['orderDataTab',
          1]],1,8,'tab',[['heading','Order Data'],['icon','assignment'],['nextButton',
          'hidden'],['previousButton','hidden']],[[2,'active',(null as any)],[2,'tab-pane',
          (null as any)]],[[(null as any),'isSelect']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i16.CalculatorComponent = _v.component;
        if (('isSelect' === en)) {
          const pd_0:any = ((<any>(_co.isFirstTabOpened = false)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(212992,[[3,4]],0,i21.TabDirective,[i21.TabsComponent,
          i0.ElementRef],{heading:[0,'heading'],disabled:[1,'disabled'],icon:[2,'icon'],
          previousButton:[3,'previousButton'],nextButton:[4,'nextButton'],index:[5,
              'index'],active:[6,'active']},{isSelect:'isSelect'}),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CalculatorComponent_7)),i0.ɵdid(16384,(null as any),0,i19.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CalculatorComponent_8)),i0.ɵdid(16384,(null as any),0,i19.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵted(1,[' '])),(_l()(),i0.ɵeld(0,(null as any),1,2,'tab',
          [['nextButton','hidden'],['previousButton','hidden']],[[2,'active',(null as any)],
              [2,'tab-pane',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i0.ɵdid(212992,[[3,4]],0,i21.TabDirective,[i21.TabsComponent,
          i0.ElementRef],{heading:[0,'heading'],disabled:[1,'disabled'],icon:[2,'icon'],
          previousButton:[3,'previousButton'],nextButton:[4,'nextButton'],index:[5,
              'index']},(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted(1,[' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' ']))],(_ck,_v) => {
    var _co:i16.CalculatorComponent = _v.component;
    const currVal_0:any = _co.order;
    _ck(_v,8,0,currVal_0);
    const currVal_1:any = ((i0.ɵnov(_v,23).activeTab && (i0.ɵnov(_v,23).activeTab.index == 1)) && !_co.hideQuote);
    _ck(_v,13,0,currVal_1);
    const currVal_2:boolean = !_co.isPublic;
    _ck(_v,18,0,currVal_2);
    _ck(_v,23,0);
    const currVal_5:any = 'Customer and Product Information';
    const currVal_6:any = 'info_outline';
    const currVal_7:any = 'hidden';
    const currVal_8:any = 0;
    const currVal_9:any = (_co.order.Status < _co.orderStatus.Calculated);
    _ck(_v,27,0,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_10:boolean = !_co.order;
    _ck(_v,30,0,currVal_10);
    const currVal_11:any = _co.order;
    _ck(_v,33,0,currVal_11);
    const currVal_14:any = 'Rate Calculator';
    const currVal_15:any = 'iso';
    const currVal_16:any = 'hidden';
    const currVal_17:any = 'hidden';
    const currVal_18:any = 1;
    const currVal_19:any = ((_co.firstAttempt && (_co.order.Status == _co.orderStatus.Calculated))? 'class.active': '');
    _ck(_v,37,0,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19);
    const currVal_20:any = _co.isProcessing;
    _ck(_v,40,0,currVal_20);
    const currVal_21:boolean = !_co.isProcessing;
    _ck(_v,43,0,currVal_21);
    const currVal_24:any = 'Order Data';
    const currVal_25:any = ((_co.order.Status == _co.orderStatus.Calculated) || _co.isPublic);
    const currVal_26:any = 'assignment';
    const currVal_27:any = 'hidden';
    const currVal_28:any = 'hidden';
    const currVal_29:any = 2;
    const currVal_30:any = ((_co.firstAttempt && (_co.order.Status > _co.orderStatus.Calculated))? 'class.active': '');
    _ck(_v,47,0,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,
        currVal_30);
    const currVal_31:boolean = !_co.order;
    _ck(_v,50,0,currVal_31);
    const currVal_32:any = (_co.order && _co.isOrderDetails);
    _ck(_v,53,0,currVal_32);
    const currVal_35:any = 'Other Information';
    const currVal_36:any = true;
    const currVal_37:any = 'help_outline';
    const currVal_38:any = 'hidden';
    const currVal_39:any = 'hidden';
    const currVal_40:any = 3;
    _ck(_v,57,0,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40);
  },(_ck,_v) => {
    const currVal_3:any = i0.ɵnov(_v,27).active;
    const currVal_4:any = i0.ɵnov(_v,27).addClass;
    _ck(_v,26,0,currVal_3,currVal_4);
    const currVal_12:any = i0.ɵnov(_v,37).active;
    const currVal_13:any = i0.ɵnov(_v,37).addClass;
    _ck(_v,36,0,currVal_12,currVal_13);
    const currVal_22:any = i0.ɵnov(_v,47).active;
    const currVal_23:any = i0.ɵnov(_v,47).addClass;
    _ck(_v,46,0,currVal_22,currVal_23);
    const currVal_33:any = i0.ɵnov(_v,57).active;
    const currVal_34:any = i0.ɵnov(_v,57).addClass;
    _ck(_v,56,0,currVal_33,currVal_34);
  });
}
export function View_CalculatorComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'calculator',([] as any[]),
      (null as any),(null as any),(null as any),View_CalculatorComponent_0,RenderType_CalculatorComponent)),
      i0.ɵdid(114688,(null as any),0,i16.CalculatorComponent,[i8.OrderService,i9.ActivatedRoute,
          i22.ExtraDataService,i9.Router,i23.PublisherService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const CalculatorComponentNgFactory:i0.ComponentFactory<i16.CalculatorComponent> = i0.ɵccf('calculator',
    i16.CalculatorComponent,View_CalculatorComponent_Host_0,{order:'order',extraData:'extraData',
        isOrderDetails:'isOrderDetails',isPublic:'isPublic',mainElement:'mainElement'},
    {orderChange:'orderChange',tabChanged:'tabChanged'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/calculator/calculator.component.ngfactory.ts